import { Injectable } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class LocalStorageService {
  getItem(key: string): string {
    return this.getLocalStorage()?.getItem(key);
  }

  setItem(key: string, value: string) {
    this.getLocalStorage()?.setItem(key, value);
  }

  removeItem(key: string) {
    this.getLocalStorage()?.removeItem(key);
  }

  private getLocalStorage(): Storage {
    return typeof window !== 'undefined' ? window.localStorage : undefined;
  }
}
